import { graphql } from "api/cms-website/generated";

export const FollowUsFragment = graphql(/* GraphQL */ `
    fragment FollowUsFragment on ComponentComponentsFollowUs {
        id
        noMarginBottom
        followUsTitle: title
        followUsSubtitle: subtitle
        followUsSocials: socials {
            icon {
                ...IconFragment
            }
            link
        }
    }
`);
